'use client';

import { useId } from 'react';
import { useTranslations } from 'next-intl';
import { cn } from '@ecom/helper-react-class-combine';
import { CtaLink } from '@/shared/components/link/cta-link';
import { pagesRoutes } from '@/shared/constants/routes';
import { openAuthGate } from '@/features/auth/shared/state/auth-gate.store';

export const WishlistSignupPrompt = () => {
  const t = useTranslations('GamePage');
  const tooltipId = useId();

  return (
    <div className='group relative inline-flex'>
      <button
        type='button'
        aria-describedby={tooltipId}
        onClick={() => openAuthGate({ view: 'register', trigger: 'wishlist' })}
        data-gtm='cta'
        data-cta-name='wishlist_signup'
        className={cn(
          'inline-flex min-w-60 items-center justify-center gap-2 border border-white px-4 py-2 select-none',
          'font-sans-bold text-text text-lg tracking-wide',
          'transition-colors hover:border-[var(--color-text-hover)] hover:text-[var(--color-text-hover)]',
        )}
      >
        {t('addToWishlist')}
      </button>
      <div
        id={tooltipId}
        role='tooltip'
        className='absolute top-full left-1/2 z-50 hidden w-96 max-w-[calc(100vw-1rem)] -translate-x-1/2 pt-2 group-focus-within:block group-hover:block'
      >
        <div className='border-border bg-background-panel text-text rounded-md border p-4 text-left text-sm shadow-lg'>
          <p>{t('wishlistSignupPrompt')}</p>
          <CtaLink
            href={pagesRoutes.register.href}
            className='mt-5 w-full justify-center'
            aria-haspopup='dialog'
            // Keep the href for new-tab and middle clicks; a plain click opens the modal instead.
            onClick={(event) => {
              event.preventDefault();
              openAuthGate({ view: 'register', trigger: 'wishlist' });
            }}
            data-gtm='cta'
            data-cta-name='wishlist_signup'
          >
            {t('wishlistSignupCta')}
          </CtaLink>
        </div>
      </div>
    </div>
  );
};
